import { formattedSimpleDate } from "utils/dateFormat"
import { HeaderContent } from "./HeaderContent"
import { HeaderLayout } from "./HeaderLayout"
import { ClarificationStatusBadge } from "../../ClarificationBadges"
import { formatIsoWithOffset } from "newui/utils/dateHelper"
import { formatClarificationRef } from "../../../utils/formatClarificationRef"
import { Clarification } from "../../../types/clarification.type"
import { ModalMode } from "../ClarificationModal"

interface HeaderProps {
	clarification: Clarification;
	mode: ModalMode;
}

export const Header = ({ clarification, mode }: HeaderProps) => {

	const viewAllData = mode === "respond" || mode === "view";
	const formattedDate = viewAllData && formatIsoWithOffset(clarification.date_due);
	return <>
		<HeaderLayout
			column1Content={<HeaderContent label="Ref #:" value={formatClarificationRef(clarification.supplier_name, clarification.reference_number)} />}
			column2Content={<HeaderContent label="Date Sent:" value={formattedSimpleDate(clarification.date_sent)} />}
			column3Content={<HeaderContent label="Status:" value={<ClarificationStatusBadge status={clarification.status} />} />}
		/>
		{viewAllData && <HeaderLayout
			column1Content={<HeaderContent label="Type:" value={clarification.clarification_type?.name || "N/A"} />}
			column2Content={<HeaderContent label="Owner:" value={clarification.owner || "N/A"} />}
			column3Content={clarification.date_due && <HeaderContent label="Response Due By:" value={formattedDate} />}
		/>}
	</>
}